
app.buttonsController = app.buttonsController || {};
app.buttonsController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        var $btnItem = $('.btnGroup > .btnGroupItem');
        if ($btnItem.length > 0) {
            $btnItem.on('click', function(e) {
                $target = $(e.target);
                $target.siblings().removeClass('is-active');
                $target.addClass('is-active');
                
                var $siblingLinkedCtn = $('#'+$target.siblings().data('link'));
                $siblingLinkedCtn.each(function(){
                    if ($(this)) {
                        $(this).removeClass('is-active');
                    }
                });
                
                var $linkedCtn = $('#'+$target.data('link'));
                if ($linkedCtn) {
                    $linkedCtn.addClass('is-active');
                }
            });
        }
    },
        
};

$(document).ready(function(){
    app.buttonsController.defaultAction.init();
});
